import React from 'react';
import { formatDuration } from '../../../src/js/lib/duration';
import { formatNumber } from '../../../src/js/lib/number';
import BarLoader from 'react-spinners/BarLoader';
import Pagination from '../../Pagination';
import apiFetch from '../../../src/js/fetch';
import Container from '../../ContentContainer';
import ContestantName from '../ContestantName';
import ProfilePicture from '../../Athletes/ProfilePicture';
import { updatePodium } from '../../../src/js/contests/leaderboard';

class DistanceLeaderboard extends React.Component {
  constructor(props) {
    super(props);

    this.followingFilter = document.querySelector('[name="filterFollowing"]');
    this.countryFilter = document.querySelector('[name="filterCountry"]');
    this.genderFilter = document.querySelector('[name="filterGender"]');

    this.state = {
      contestId: props.contest_id,
      challengeType: props.distance_challenge_type,
      userId: props.user_id,
      contestants: [],
      loading: true,

      numPages: 1,
      currentPage: 1,

      orderBy: 'total_distance_in_meters',
      filterTimeFrom: '',
      filterTimeTo: '',
      filterCountry: this.countryFilter?.value || 'all',
      filterGender: this.genderFilter?.value || 'all',
      filterFollowing: this.followingFilter?.value || 'all',
      openFilter: false,
    };
  }

  componentDidMount() {
    this.fetchContestants(this.state.currentPage);

    window.reloadLeaderboard = this.reloadLeaderboard;

    // Listen for filter changes
    this.countryFilter.addEventListener('change', this.onChange);
    this.genderFilter.addEventListener('change', this.onChange);
    this.followingFilter.addEventListener('change', this.onChange);

    document.body.addEventListener('click', this.handleClickOutsideFilter);

    // Hide month filter
    document.querySelector('[name="filterMonth"]').classList.add('hidden');
  }

  reloadLeaderboard = () => {
    this.setState({ currentPage: 1, contestants: [], loading: true }, () => {
      this.fetchContestants(this.state.currentPage);
    });
  };

  componentWillUnmount() {
    window.reloadLeaderboard = null;
    document.body.removeEventListener('click', this.handleClickOutsideFilter);

    this.countryFilter.removeEventListener('change', this.onChange);
    this.genderFilter.removeEventListener('change', this.onChange);
    this.followingFilter.removeEventListener('change', this.onChange);
  }

  onPaginate = (page) => {
    this.setState({ currentPage: page }, () => {
      this.fetchContestants(page);
    });
  };

  fetchContestants = async (page) => {
    this.setState({ loading: true });

    const {
      contestId,
      filterCountry,
      filterGender,
      filterFollowing,
      initialFetched,
    } = this.state;
    try {
      const data = await apiFetch(`/api/challenges/leaderboard`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          contest_id: contestId,
          page: page,
          filter: {
            gender: filterGender,
            country: filterCountry,
            following: filterFollowing,
          },
          //   order: {
          //     month: filterMonth,
          //     // field: orderBy,
          //   },
        }),
      });

      console.log({ data });

      this.setState({
        initialFetched: true,
        contestants: data.contestants,
        numPages: data.total_pages,
        perPage: data.per_page,
      });
      if (initialFetched) {
        updatePodium(data.contestants, data.filtered, page);
      }
    } catch (e) {
      console.log({ e });
      const err = e.json ? await e.json() : null;
      console.log({ err });

      this.setState({
        loading: false,
        error:
          (err && err.error_message) ||
          'Something went wrong. Please try again later.',
      });
    }
    this.setState({ loading: false });
  };

  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value, currentPage: 1 }, () => {
      this.fetchContestants(1);
    });
  };

  toggleFilter = () => {
    this.setState({ openFilter: !this.state.openFilter });
  };

  handleClickOutsideFilter = (e) => {
    if (
      this.state.openFilter &&
      !e.target.closest('.challenge-leaderboard-filter') &&
      !e.target.closest('.filter-trigger')
    ) {
      this.setState({ openFilter: false });
    }
  };

  render() {
    const {
      contestants,
      numPages,
      currentPage,
      userId,
      challengeType,
      orderBy,
    } = this.state;

    return (
      <>
        <Container>
          <h2 className='mini-label font-medium'>Leaderboard</h2>
          <div className='w-full overflow-x-auto challenge-leaderboard'>
            <table className='w-full border-spacing-y-2 border-separate'>
              <thead className=''>
                <tr className=''>
                  <th className=''>#</th>
                  <th className=''>Contestant</th>
                  <th className=''>
                    Longest{' '}
                    {challengeType === 'RUNNING'
                      ? 'run'
                      : challengeType === 'CYCLING'
                      ? 'ride'
                      : 'activity'}
                  </th>
                  {challengeType === 'RUNNING' && (
                    <th className=''>Avg. pace</th>
                  )}
                  <th className=''>Elevation</th>
                  <th className=''>Duration</th>
                  <th className=''>Kilometers</th>
                </tr>
              </thead>
              <tbody>
                <tr className='h-2' data-spacer></tr>
                {contestants.map((contestant, i) => (
                  <tr
                    key={contestant.id}
                    className={`${
                      contestant.user_id === userId
                        ? 'current-user font-medium'
                        : ''
                    }`}
                  >
                    <td className=''>
                      {contestant.filtered
                        ? contestant[orderBy] && contestant[orderBy] > 0
                          ? `${i + 1}.`
                          : '-'
                        : contestant?.position && contestant.position > 0
                        ? `${contestant.position}.`
                        : '-'}
                      {/* {contestant?.position && contestant.position > 0
                        ? `${contestant.position}.`
                        : '-'} */}
                    </td>
                    <td className='flex items-center'>
                      <ProfilePicture {...contestant.user} />
                      <ContestantName contestant={contestant} userId={userId} />
                    </td>
                    <td className=''>
                      {contestant.longest_activity_in_meters
                        ? formatNumber(
                            (
                              contestant.longest_activity_in_meters / 1000
                            ).toFixed(2)
                          )
                        : '0'}{' '}
                      km
                    </td>
                    {challengeType === 'RUNNING' && (
                      <td className=''>
                        {contestant.avg_pace
                          ? formatDuration(contestant.avg_pace)
                          : '00:00'}{' '}
                        / km
                      </td>
                    )}
                    <td className=''>
                      {contestant.total_elevation_gain_in_meters
                        ? formatNumber(
                            contestant.total_elevation_gain_in_meters.toFixed(0)
                          )
                        : '0'}{' '}
                      m
                    </td>
                    <td className=''>
                      {contestant.duration
                        ? formatDuration(contestant.duration)
                        : '00:00'}
                    </td>
                    <td className=''>
                      {contestant.total_distance_in_meters
                        ? formatNumber(
                            (
                              contestant.total_distance_in_meters / 1000
                            ).toFixed(2)
                          )
                        : '0'}{' '}
                      km
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            {this.state.loading ? <BarLoader /> : null}

            <Pagination
              numPages={numPages}
              currentPage={currentPage}
              onPaginate={this.onPaginate}
            />
          </div>
        </Container>
      </>
    );
  }
}
export default DistanceLeaderboard;
